// import consts
import { DATE_TODAY, DATE_TOMORROW, CURRENT_DATE, WEBPSUPPORT } from 'js/constants/App';

export const isRTL = () => {
  let direction;
  document.dir !== undefined
    ? (direction = document.dir)
    : (direction = document.getElementsByTagName('html')[0].getAttribute('dir'));
  return direction === 'rtl';
};

export const isValidDate = (e, t, n) => {
  const r = new Date(n, t - 1, e);
  return r.getFullYear() == n && r.getMonth() + 1 == t && r.getDate() == e;
};

export const isObjectEmpty = (obj) => {
  return Object.keys(obj).length === 0;
};

export const shuffleArray = (array) =>
  array
    .map((a) => ({ sort: Math.random(), value: a }))
    .sort((a, b) => a.sort - b.sort)
    .map((a) => a.value);

export const preventFullScreenOverflow = (hide = false) => {
  document.getElementsByTagName('html')[0].style.overflow = hide ? 'hidden' : '';
  document.body.style.overflow = hide ? 'hidden' : '';
};

/**
 * Convert an object to string, for log/debug purposes
 * @param obj - Object to be stringified
 */
export const objToStr = (obj) => {
  const items = [];
  for (const k in obj) {
    if ({}.hasOwnProperty.call(obj, k)) {
      items.push(`${k}:${obj[k]}`);
    }
  }
  return `{${items.join(', ')}}`;
};

export const formatDate = (time) => {
  const serverDate = time;
  const date = new Date(serverDate);
  const options = { day: 'numeric', month: 'long', year: 'numeric' };
  const formattedDate = date.toLocaleDateString('en-GB', options).replace(/(\d+)/, (_, day) => {
    let suffix = 'th';
    if (day % 10 === 1 && day % 100 !== 11) {
      suffix = 'st';
    } else if (day % 10 === 2 && day % 100 !== 12) {
      suffix = 'nd';
    } else if (day % 10 === 3 && day % 100 !== 13) {
      suffix = 'rd';
    }
    return `${day}${suffix}`;
  });

  return formattedDate;
};

import { dynamicAssets } from 'js/constants/Paths';

export const parseSrcSetImages = (array) => {
  const imgSrc = {};
  array.sort((a, b) => {
    return b.width - a.width;
  });

  const imageArray = array.map((image, index) => {
    const { width, file_name } = image;
    const size = index === 0 ? 'large' : index == 1 ? 'medium' : 'small';
    imgSrc[size] = {
      width,
      src: dynamicAssets(file_name),
    };
  });

  return imgSrc;
};

// date range / formatting
const formattedTimestamp = (date) => {
  const DATE_OFFSET_DAY = date.getDate();
  const DATE_OFFSET_MONTH = date.getMonth() + 1;
  const DATE_OFFSET_YEAR = date.getFullYear();
  return Date.parse(DATE_OFFSET_MONTH + '/' + DATE_OFFSET_DAY + '/' + DATE_OFFSET_YEAR) / 1000;
};

export const dateRange = (offsetDate) => {
  const currentDateId = new Date().getDay();

  const DATE_OFFSET = new Date();
  const DATE_PREVIOUS_WEEK = new Date();

  // if the offset matches the currentdateID
  if (currentDateId === offsetDate || (currentDateId === 0 && offsetDate === 7)) {
    DATE_PREVIOUS_WEEK.setDate(DATE_PREVIOUS_WEEK.getDate() - 6);

    return {
      current: DATE_TODAY / 1000,
      prev_week: formattedTimestamp(DATE_PREVIOUS_WEEK),
    };
  }

  // if currentdtaeId is not 0 but offsetDate is 7 (7 is how the design treats Sunday)
  if (currentDateId !== 0 && offsetDate === 7) {
    DATE_OFFSET.setDate(DATE_OFFSET.getDate() + (offsetDate - currentDateId));
    DATE_PREVIOUS_WEEK.setDate(DATE_OFFSET.getDate() - 6);

    return {
      current: formattedTimestamp(DATE_OFFSET),
      prev_week: formattedTimestamp(DATE_PREVIOUS_WEEK),
    };
  }

  if (currentDateId > offsetDate) {
    DATE_OFFSET.setDate(DATE_OFFSET.getDate() - Math.abs(offsetDate - currentDateId));
  } else {
    DATE_OFFSET.setDate(DATE_OFFSET.getDate() + Math.abs(offsetDate - currentDateId));
  }
  DATE_PREVIOUS_WEEK.setDate(DATE_OFFSET.getDate() - 6);

  return {
    current: formattedTimestamp(DATE_OFFSET),
    prev_week: formattedTimestamp(DATE_PREVIOUS_WEEK),
  };
};

export const windowScrollTo = (pos) => {
  window.scrollTo({
    top: pos,
    left: 0,
    behavior: 'smooth',
  });
};

//stackoverflow.com/questions/5573096/detecting-webp-support
export const canUseWebP = () => {
  const elem = document.createElement('canvas');
  // eslint-disable-next-line no-extra-boolean-cast
  if (!!(elem.getContext && elem.getContext('2d'))) {
    const testString = !(window.mozInnerScreenX == null) ? 'png' : 'webp';
    // was able or not to get WebP representation

    if (elem.toDataURL('image/webp').indexOf('data:image/' + testString) == 0) {
      document.documentElement.classList.add('webp');
      return true;
    }
  }
  // very old browser like IE 8, canvas not supported
  return false;
};

export const convertFileExtensionToWebp = (url) => {
  if (!url) {
    return '';
  }
  return WEBPSUPPORT
    ? url.replace(new RegExp('.(' + ['jpg', 'jpeg', 'png', 'JPG', 'PNG', 'JPEG'].join('|') + ')$', 'i'), '.webp')
    : url;
};

export const processImages = (placeholder, images, widths = ['1x', '2x', '3x']) => {
  const imgs = images.map((image) => {
    return convertFileExtensionToWebp(image);
  });
  const srcSet = imgs.reduce((acc, image, index) => {
    if (image && image !== '') {
      const width = widths[index] || '';
      acc += `${image} ${width}`;
      if (index < imgs.length - 1) {
        acc += ', ';
      }
    }
    return acc;
  }, '');
  const placeholder_lazy = convertFileExtensionToWebp(placeholder);
  const src = DEVICE === 'desktop' ? imgs[2] : imgs[0];
  return { placeholder_lazy, srcSet, src };
};
